import { RootState } from '@reducers';

export const selectVehicleDetails = (state: RootState) => state.userDashboardRouteReducer.vehicleDetails;
